import React, { useMemo } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import {
  MediaMessageTextWithIconBody,
  MessageBodyDirection,
} from 'common/builder/components/chart/FlowChart/types/FlowChartMediaMessageBlock'

interface MediaMessageTextWithIconBodyProps {
  body: MediaMessageTextWithIconBody
}

export const TextWithIconContent = ({
  body: { icon: IconComponent, iconColor, text, direction },
}: MediaMessageTextWithIconBodyProps) => {
  const iconString = useMemo(
    () =>
      IconComponent
        ? renderToStaticMarkup(
            <IconComponent color={iconColor || undefined} size={sharedStyles.IconSizes.NORMAL} />,
          )
        : null,
    [IconComponent, iconColor],
  )
  return (
    <TextWithIcon icon={iconString} row={direction === MessageBodyDirection.ROW}>
      {text}
    </TextWithIcon>
  )
}
